import { render, staticRenderFns } from "./DatasetSummary.vue?vue&type=template&id=d712ab68&scoped=true"
import script from "./DatasetSummary.vue?vue&type=script&lang=js"
export * from "./DatasetSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d712ab68",
  null
  
)

export default component.exports